import { WebApiService } from '../../../plugins/webApiService'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import GetShortTaskByIdRequest from '../../../projects/task/i-service/models/task/request/GetShortTaskByIdRequest';
import GetGroupedByStatusTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByStatusTaskListRequest';
import GetByStatusTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByStatusTaskListRequest';
import GetGroupedByPriorityTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByPriorityTaskListRequest';
import GetByPriorityTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByPriorityTaskListRequest';
import GetWithoutGroupingTaskListRequest from '../../../projects/task/i-service/models/task/request/GetWithoutGroupingTaskListRequest';
import GetGroupedByPerformerTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByPerformerTaskListRequest';
import GetByPerformerTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByPerformerTaskListRequest';
import GetGroupedByTagTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByTagTaskListRequest';
import GetByTagTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByTagTaskListRequest';
import GetGroupedByTypeTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByTypeTaskListRequest';
import GetByTypeTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByTypeTaskListRequest';
import GetGroupedByOwnerTaskListRequest from '../../../projects/task/i-service/models/task/request/GetGroupedByOwnerTaskListRequest';
import GetByOwnerTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByOwnerTaskListRequest';
import GetByParentTaskListRequest from '../../../projects/task/i-service/models/task/request/GetByParentTaskListRequest';
import GetTaskListByTreeShortRequest from '../../../projects/task/i-service/models/task/request/GetTaskListByTreeShortRequest';
import GetTaskShortListRequest from '../../../projects/task/i-service/models/task/request/GetTaskShortListRequest';
import GetSubtaskShortListRequest from '../../../projects/task/i-service/models/task/request/GetSubtaskShortListRequest';
import GetTaskByIdRequest from '../../../projects/task/i-service/models/task/request/GetTaskByIdRequest';
import GetTaskDiagramRelationRequest from '../../../projects/task/i-service/models/task/request/GetTaskDiagramRelationRequest';
import GetQueueParentTaskByQueueTaskIdsRequest from '../../../projects/task/i-service/models/task/request/GetQueueParentTaskByQueueTaskIdsRequest';
import GetPerformersTaskRequest from '../../../projects/task/i-service/models/task/request/GetPerformersTaskRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import GetShortTaskByIdResponse from '../../../projects/task/i-service/models/task/response/GetShortTaskByIdResponse';
import GetGroupedByStatusTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByStatusTaskListResponse';
import GetByStatusTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByStatusTaskListResponse';
import GetGroupedByPriorityTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByPriorityTaskListResponse';
import GetByPriorityTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByPriorityTaskListResponse';
import GetWithoutGroupingTaskListResponse from '../../../projects/task/i-service/models/task/response/GetWithoutGroupingTaskListResponse';
import GetGroupedByPerformerTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByPerformerTaskListResponse';
import GetByPerformerTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByPerformerTaskListResponse';
import GetGroupedByTagTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByTagTaskListResponse';
import GetByTagTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByTagTaskListResponse';
import GetGroupedByTypeTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByTypeTaskListResponse';
import GetByTypeTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByTypeTaskListResponse';
import GetGroupedByOwnerTaskListResponse from '../../../projects/task/i-service/models/task/response/GetGroupedByOwnerTaskListResponse';
import GetByOwnerTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByOwnerTaskListResponse';
import GetByParentTaskListResponse from '../../../projects/task/i-service/models/task/response/GetByParentTaskListResponse';
import GetTaskListByTreeShortResponse from '../../../projects/task/i-service/models/task/response/GetTaskListByTreeShortResponse';
import GetTaskShortListResponse from '../../../projects/task/i-service/models/task/response/GetTaskShortListResponse';
import GetSubtaskShortListResponse from '../../../projects/task/i-service/models/task/response/GetSubtaskShortListResponse';
import GetTaskByIdResponse from '../../../projects/task/i-service/models/task/response/GetTaskByIdResponse';
import GetTaskDiagramRelationResponse from '../../../projects/task/i-service/models/task/response/GetTaskDiagramRelationResponse';
import GetQueueParentTaskByQueueTaskIdsResponse from '../../../projects/task/i-service/models/task/response/GetQueueParentTaskByQueueTaskIdsResponse';
import GetPerformersTaskResponse from '../../../projects/task/i-service/models/task/response/GetPerformersTaskResponse';

/**
 * * Сервис для получения информации о задачах
 */
export default class ProjectTaskGetService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	
	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
	}

	/**
	 * * Получение короткой информации о задаче по id
	 */
	async GetShortTaskById(request: GetShortTaskByIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetShortTaskById',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по статусу
	 */
	async GetGroupedByStatusTaskList(request: GetGroupedByStatusTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByStatusTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по статусу
	 */
	async GetByStatusTaskList(request: GetByStatusTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByStatusTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по приоритету
	 */
	async GetGroupedByPriorityTaskList(request: GetGroupedByPriorityTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByPriorityTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по приоритету
	 */
	async GetByPriorityTaskList(request: GetByPriorityTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByPriorityTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач без группировки
	 */
	async GetWithoutGroupingTaskList(request: GetWithoutGroupingTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetWithoutGroupingTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по исполнителю
	 */
	async GetGroupedByPerformerTaskList(request: GetGroupedByPerformerTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByPerformerTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по исполнителю
	 */
	async GetByPerformerTaskList(request: GetByPerformerTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByPerformerTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по тегам
	 */
	async GetGroupedByTagTaskList(request: GetGroupedByTagTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByTagTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по тегу
	 */
	async GetByTagTaskList(request: GetByTagTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByTagTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по типу
	 */
	async GetGroupedByTypeTaskList(request: GetGroupedByTypeTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByTypeTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по типу
	 */
	async GetByTypeTaskList(request: GetByTypeTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByTypeTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение сгруппированных задач по владельцам
	 */
	async GetGroupedByOwnerTaskList(request: GetGroupedByOwnerTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetGroupedByOwnerTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач по создателю
	 */
	async GetByOwnerTaskList(request: GetByOwnerTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByOwnerTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение задач по родителю
	 */
	async GetByParentTaskList(request: GetByParentTaskListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetByParentTaskList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка задач с короткой информацией по дереву
	 */
	async GetTaskListByTreeShort(request: GetTaskListByTreeShortRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetTaskListByTreeShort',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получнеие списка задач с короткой информацией
	 */
	async GetTaskShortList(request: GetTaskShortListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetTaskShortList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получнеие списка задач с короткой информацией для добавления как подзадачи
	 */
	async GetSubtaskShortList(request: GetSubtaskShortListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetSubtaskShortList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение детальной задачи
	 */
	async GetById(request: GetTaskByIdRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetById',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение диаграммы связей задачи
	 */
	async GetTaskDiagramRelation(request: GetTaskDiagramRelationRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetTaskDiagramRelation',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение информации о родительских задачах по списку id очередей
	 */
	async GetQueueParentTaskByQueueTaskIds(request: GetQueueParentTaskByQueueTaskIdsRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetQueueParentTaskByQueueTaskIds',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Метод для получения исполнителей по задаче(с проверкой на доступ к очереди)
	 */
	async GetPerformersTask(request: GetPerformersTaskRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'ProjectTaskGetService',
			Method: 'GetPerformersTask',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получение короткой информации о задаче по id
	 */
	async getShortTaskByIdAsync(request: GetShortTaskByIdRequest): Promise<GetShortTaskByIdResponse> {
		return new Promise<GetShortTaskByIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetShortTaskById',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetShortTaskByIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetShortTaskByIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по статусу
	 */
	async getGroupedByStatusTaskListAsync(request: GetGroupedByStatusTaskListRequest): Promise<GetGroupedByStatusTaskListResponse> {
		return new Promise<GetGroupedByStatusTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByStatusTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByStatusTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByStatusTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по статусу
	 */
	async getByStatusTaskListAsync(request: GetByStatusTaskListRequest): Promise<GetByStatusTaskListResponse> {
		return new Promise<GetByStatusTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByStatusTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByStatusTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByStatusTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по приоритету
	 */
	async getGroupedByPriorityTaskListAsync(request: GetGroupedByPriorityTaskListRequest): Promise<GetGroupedByPriorityTaskListResponse> {
		return new Promise<GetGroupedByPriorityTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByPriorityTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByPriorityTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByPriorityTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по приоритету
	 */
	async getByPriorityTaskListAsync(request: GetByPriorityTaskListRequest): Promise<GetByPriorityTaskListResponse> {
		return new Promise<GetByPriorityTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByPriorityTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByPriorityTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByPriorityTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач без группировки
	 */
	async getWithoutGroupingTaskListAsync(request: GetWithoutGroupingTaskListRequest): Promise<GetWithoutGroupingTaskListResponse> {
		return new Promise<GetWithoutGroupingTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetWithoutGroupingTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetWithoutGroupingTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetWithoutGroupingTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по исполнителю
	 */
	async getGroupedByPerformerTaskListAsync(request: GetGroupedByPerformerTaskListRequest): Promise<GetGroupedByPerformerTaskListResponse> {
		return new Promise<GetGroupedByPerformerTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByPerformerTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByPerformerTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByPerformerTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по исполнителю
	 */
	async getByPerformerTaskListAsync(request: GetByPerformerTaskListRequest): Promise<GetByPerformerTaskListResponse> {
		return new Promise<GetByPerformerTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByPerformerTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByPerformerTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByPerformerTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по тегам
	 */
	async getGroupedByTagTaskListAsync(request: GetGroupedByTagTaskListRequest): Promise<GetGroupedByTagTaskListResponse> {
		return new Promise<GetGroupedByTagTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByTagTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByTagTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByTagTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по тегу
	 */
	async getByTagTaskListAsync(request: GetByTagTaskListRequest): Promise<GetByTagTaskListResponse> {
		return new Promise<GetByTagTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByTagTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByTagTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByTagTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по типу
	 */
	async getGroupedByTypeTaskListAsync(request: GetGroupedByTypeTaskListRequest): Promise<GetGroupedByTypeTaskListResponse> {
		return new Promise<GetGroupedByTypeTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByTypeTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByTypeTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByTypeTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по типу
	 */
	async getByTypeTaskListAsync(request: GetByTypeTaskListRequest): Promise<GetByTypeTaskListResponse> {
		return new Promise<GetByTypeTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByTypeTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByTypeTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByTypeTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение сгруппированных задач по владельцам
	 */
	async getGroupedByOwnerTaskListAsync(request: GetGroupedByOwnerTaskListRequest): Promise<GetGroupedByOwnerTaskListResponse> {
		return new Promise<GetGroupedByOwnerTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetGroupedByOwnerTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetGroupedByOwnerTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetGroupedByOwnerTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач по создателю
	 */
	async getByOwnerTaskListAsync(request: GetByOwnerTaskListRequest): Promise<GetByOwnerTaskListResponse> {
		return new Promise<GetByOwnerTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByOwnerTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByOwnerTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByOwnerTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение задач по родителю
	 */
	async getByParentTaskListAsync(request: GetByParentTaskListRequest): Promise<GetByParentTaskListResponse> {
		return new Promise<GetByParentTaskListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetByParentTaskList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetByParentTaskListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetByParentTaskListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка задач с короткой информацией по дереву
	 */
	async getTaskListByTreeShortAsync(request: GetTaskListByTreeShortRequest): Promise<GetTaskListByTreeShortResponse> {
		return new Promise<GetTaskListByTreeShortResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetTaskListByTreeShort',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetTaskListByTreeShortResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetTaskListByTreeShortResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получнеие списка задач с короткой информацией
	 */
	async getTaskShortListAsync(request: GetTaskShortListRequest): Promise<GetTaskShortListResponse> {
		return new Promise<GetTaskShortListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetTaskShortList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetTaskShortListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetTaskShortListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получнеие списка задач с короткой информацией для добавления как подзадачи
	 */
	async getSubtaskShortListAsync(request: GetSubtaskShortListRequest): Promise<GetSubtaskShortListResponse> {
		return new Promise<GetSubtaskShortListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetSubtaskShortList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetSubtaskShortListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetSubtaskShortListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение детальной задачи
	 */
	async getByIdAsync(request: GetTaskByIdRequest): Promise<GetTaskByIdResponse> {
		return new Promise<GetTaskByIdResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetById',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetTaskByIdResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetTaskByIdResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение диаграммы связей задачи
	 */
	async getTaskDiagramRelationAsync(request: GetTaskDiagramRelationRequest): Promise<GetTaskDiagramRelationResponse> {
		return new Promise<GetTaskDiagramRelationResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetTaskDiagramRelation',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetTaskDiagramRelationResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetTaskDiagramRelationResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение информации о родительских задачах по списку id очередей
	 */
	async getQueueParentTaskByQueueTaskIdsAsync(request: GetQueueParentTaskByQueueTaskIdsRequest): Promise<GetQueueParentTaskByQueueTaskIdsResponse> {
		return new Promise<GetQueueParentTaskByQueueTaskIdsResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetQueueParentTaskByQueueTaskIds',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetQueueParentTaskByQueueTaskIdsResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetQueueParentTaskByQueueTaskIdsResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Метод для получения исполнителей по задаче(с проверкой на доступ к очереди)
	 */
	async getPerformersTaskAsync(request: GetPerformersTaskRequest): Promise<GetPerformersTaskResponse> {
		return new Promise<GetPerformersTaskResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'ProjectTaskGetService',
				Method: 'GetPerformersTask',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetPerformersTaskResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetPerformersTaskResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}